import { render, staticRenderFns } from "./ManagerLayout.vue?vue&type=template&id=28289758&scoped=true"
import script from "./ManagerLayout.vue?vue&type=script&lang=js"
export * from "./ManagerLayout.vue?vue&type=script&lang=js"
import style0 from "./ManagerLayout.vue?vue&type=style&index=0&id=28289758&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28289758",
  null
  
)

export default component.exports